(function () {
  function getFormVariantId(form, formId) {
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput && formId) idInput = document.querySelector('input[name="id"][form="' + formId + '"]');
    if (idInput) return idInput.value;
    let idSelect = form.querySelector('select[name="id"]');
    if (!idSelect && formId) idSelect = document.querySelector('select[name="id"][form="' + formId + '"]');
    if (idSelect) return idSelect.value;
    return null;
  }

  function getFormQuantity(form, formId) {
    let qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput && formId) qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    if (qtyInput && qtyInput.value) return parseInt(qtyInput.value, 10) || 1;
    return 1;
  }

  function getFormProperties(form, formId) {
    const props = {};
    const inputs = document.querySelectorAll('input[form="' + formId + '"], select[form="' + formId + '"], textarea[form="' + formId + '"]');
    const inForm = form.querySelectorAll('input, select, textarea');
    function collect(list) {
      list.forEach(function (el) {
        const name = el.name;
        if (!name || name === 'id' || name === 'quantity' || el.disabled) return;
        if (name.indexOf('properties[') === 0) {
          const val = el.type === 'checkbox' ? (el.checked ? el.value : null) : el.value;
          if (val != null && val !== '') {
            const key = name.slice(11, -1);
            props[key] = val;
          }
        }
      });
    }
    collect(Array.from(inputs));
    collect(Array.from(inForm));
    return props;
  }

  function openCartDrawer() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.theme && window.Shopify.theme.cartDrawer) {
      window.Shopify.theme.cartDrawer.open();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  function setButtonState(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    const textEl = btn.querySelector('[data-add-to-cart-text]');
    if (textEl) textEl.style.visibility = loading ? 'hidden' : '';
    btn.classList.toggle('is-loading', loading);
  }

  function showFormError(form, message) {
    const container = form.querySelector('[data-cart-errors-container]');
    if (container) {
      container.innerHTML = '<p class="product-form__error">' + (message || 'Unable to add to cart.') + '</p>';
      container.style.display = 'block';
    } else {
      alert(message || 'Unable to add to cart.');
    }
  }

  function clearFormError(form) {
    const container = form.querySelector('[data-cart-errors-container]');
    if (container) {
      container.innerHTML = '';
      container.style.display = '';
    }
  }

  function doAddToCartWithAddons(addonsSection, form, formId, atcBtn) {
    const selected = addonsSection.querySelectorAll('[data-addon-checkbox]:checked');
    if (selected.length === 0) return false;

    if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) {
      return true;
    }

    const mainVariantId = getFormVariantId(form, formId);
    if (!mainVariantId) {
      showFormError(form, 'Please select a variant.');
      return true;
    }

    const quantity = getFormQuantity(form, formId);
    const properties = getFormProperties(form, formId);
    const mainItem = { id: parseInt(mainVariantId, 10), quantity: quantity };
    if (Object.keys(properties).length) mainItem.properties = properties;
    const items = [mainItem];

    selected.forEach(function (cb) {
      const item = cb.closest('[data-addon-item]');
      if (item && item.getAttribute('data-available') === 'true') {
        const variantId = item.getAttribute('data-variant-id');
        if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
      }
    });

    if (items.length <= 1) return false;

    clearFormError(form);
    setButtonState(atcBtn, true);

    var cartAddUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var msg = data && (data.description || data.message) ? data.description || data.message : 'Could not add to cart';
            throw new Error(msg);
          }
          if (data.status && data.status !== 200) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          return data;
        });
      })
      .then(function () {
        setButtonState(atcBtn, false);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        setTimeout(function () {
          openCartDrawer();
        }, 350);
        addonsSection.querySelectorAll('[data-addon-checkbox]:checked').forEach(function (cb) { cb.checked = false; });
      })
      .catch(function (err) {
        setButtonState(atcBtn, false);
        showFormError(form, err.message || 'Unable to add to cart.');
      });

    return true;
  }

  function init() {
    const addonsSection = document.querySelector('[data-product-addons]');
    if (!addonsSection) return;

    const formId = addonsSection.getAttribute('data-product-form-id');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    const atcBtn = form.querySelector('[data-add-to-cart]');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function (e) {
      const selected = addonsSection.querySelectorAll('[data-addon-checkbox]:checked');
      if (selected.length === 0) return;

      if (doAddToCartWithAddons(addonsSection, form, formId, atcBtn)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    form.addEventListener('submit', function (e) {
      const selected = addonsSection.querySelectorAll('[data-addon-checkbox]:checked');
      if (selected.length === 0) return;

      if (doAddToCartWithAddons(addonsSection, form, formId, atcBtn)) {
        e.preventDefault();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
